@if (accountNumber && variableSymbol) {
  <div class="qr-code-image">
    <div>
      @if (!qrImageData()) {
        <div >{{  getQrString() }}</div>
      }
      @if (qrImageData()) {
        <img src="{{ qrImageData() }}" alt="">
      }
    </div>
  </div>
  <button class="qr-code-download" (click)="downloadImg()">
    {{ 'moneyAndTransactions.downloadQrCode' | translate }}
  </button>
}